import styled from 'styled-components';

export const TruckPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.limedSpruce};

  .statistics {
    margin-bottom: 32px;
    margin-top: 20px;
  }

  @media (max-width: 1024px) {
    .availability-date {
      padding: 0 22px;
    }
  }

  @media screen and (max-width: 768px) {
    .statistics {
      margin: 0 0 5px 0;
    }
  }

  @media screen and (max-width: 512px) {
    .statistics {
      margin: 0;
    }

    .availability-date {
      padding: 0 9px;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 512px) {
    padding: 0px 10px;
  }
`;

export const PriceContainer = styled.div`
  flex: 1;
  margin-left: 32px;
  align-self: flex-end;
  @media (max-width: 1024px) {
    margin-left: 0;
    align-self: inherit;
  }
`;

export const TitleAndPriceWrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize.lg};

  display: flex;
  flex: 2;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const AddressAndPublicationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 4px;
  flex: 1;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const BodyContainer = styled.div`
  display: flex;
  justify-content: space-between;

  &.skeleton {
    margin-top: 10px;
  }
`;

export const Body = styled.div`
  position: relative;
  flex: 2;
  display: flex;
  flex-direction: column;
`;

export const DesktopSidebarContainer = styled.div`
  flex: 1;
  margin-left: 32px;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const MobileSidebarContainer = styled.div`
  display: none;

  @media screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    padding-top: 22px;
  }

  @media screen and (max-width: 512px) {
    padding-top: 5px;
  }
`;

export const SideBarUserData = styled.div`
  overflow: hidden;
  padding: 30px 0;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
`;

export const MobileUserData = styled.div`
  overflow: hidden;
  padding: 30px 0;
  display: none;

  @media (max-width: 650px) {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 320px) {
    display: none;
  }
`;

export const MobileHorizontUserData = styled.div`
  overflow: hidden;
  margin: 20px 0;
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 650px) {
    display: none;
  }
`;

export const HorizontalUserData = styled.div`
  overflow: hidden;
  margin: 20px 0;
  display: flex;
  justify-content: center;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const SocialButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;

  .descr {
    display: inline-block;
    margin: 0 10px 0 0;
  }

  .ya-share2__badge {
    border-radius: 50%;
  }

  && .ya-share2__icon {
    height: 34px;
    width: 34px;
    background-size: 34px 34px;
  }

  @media (max-width: 1024px) {
    justify-content: flex-start;
  }

  @media (max-width: 512px) {
    .descr {
      margin-left: 5px;
    }
  }
`;
